import { render, staticRenderFns } from "./BlogHome.vue?vue&type=template&id=5fcaa323"
import script from "./BlogHome.vue?vue&type=script&lang=ts"
export * from "./BlogHome.vue?vue&type=script&lang=ts"
import style0 from "./BlogHome.vue?vue&type=style&index=0&id=5fcaa323&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports